import m from "./ghl-ui.es1505.js";
import f from "./ghl-ui.es1506.js";
import i from "./ghl-ui.es1578.js";
import s from "./ghl-ui.es1466.js";
function d(t, r) {
  s(2, arguments);
  var e = f(t), o = m(r), a = i(e) - o;
  return e.setUTCDate(e.getUTCDate() - a * 7), e;
}
export {
  d as default
};
